import OSprite from "../sprites/OSprite";
import { OmyConst } from "../../OmyConst";
import Omy from "../../Omy";

export default class OButton extends OSprite {
    constructor(outTexture, atlas = null, overTexture = null, downTexture = null, blockTexture = null, conf = null) {
        super(outTexture, atlas);
        this._oType = OmyConst.OMY_BUTTON;

        this._gdConf = conf || {};

        this._outTexture = outTexture;
        this._overTexture = overTexture;
        this._downTexture = downTexture;
        this._blockrTexture = blockTexture;
        this._label = null;
        this._hintLabel = null;
        this._blockAlphaLvl = this._gdConf["blockAlpha"];
        this._isHasBlockAlpha = this._gdConf.hasOwnProperty("blockAlpha");

        this._currentTexture = outTexture;

        this.input = true;
        this.buttonMode = true;
        this._isBlock = false;
        this._inDown = false;
        this._inButton = false;

        this._oneClick = false;

        if (!Omy.isDesktop) {
            this.buttonMode = false;
            this.removeListener("pointerover", this._over, this);
            this.removeListener("pointerout", this._out, this);
        }
    }

    changeTextures(outFrame, overFrame = null, downFrame = null, blockFrame = null) {
        this._currentTexture = (this._currentTexture === this._blockrTexture) ? blockFrame : outFrame;
        this._outTexture = outFrame;
        this._overTexture = overFrame;
        this._downTexture = downFrame;
        this._blockrTexture = blockFrame;

        this._updateBtnGraphic();
    }

    _updateBtnGraphic() {
        if (typeof this._currentTexture === "string") {
            if (this.textureName !== this._currentTexture)
                this.texture = this._currentTexture;
        } else {
            if (this.texture !== this._currentTexture)
                this.texture = this._currentTexture;
        }
    }

    revive() {
        super.revive();
        this._inDown = false;
        this.isBlock = false;
        this._inButton = false;
        this._currentTexture = this._outTexture;

        this._updateBtnGraphic();
        return this;
    }

    kill() {
        this.isBlock = true;

        return super.kill();
    }

    destroy(options) {
        if (this._label) {
            this.removeChild(this._label);
            this._label.destroy({ children: true, texture: false, baseTexture: false });
            this._label = null;
        }
        if (this._hintLabel) {
            this._hintLabel.destroy({ children: true, texture: false, baseTexture: false });
            this._hintLabel = null;
        }
        this._gdConf = null;
        this._outTexture = null;
        this._overTexture = null;
        this._downTexture = null;
        this._blockrTexture = null;
        this._currentTexture = null;

        return super.destroy(options);
    }

    _onDownHandler() {
    }

    _onOverHandler() {
        if (this._hintLabel) {
            if (this.parent) this.parent.addChild(this._hintLabel);
            this._hintLabel.visible = true;
        }
    }

    _onOutHandler() {
        if (this._hintLabel) {
            if (this.parent) this.parent.removeChild(this._hintLabel);
            this._hintLabel.visible = false;
        }
    }

    _onUpHandler() {
    }

    _down() {
        if (this._isBlock) return;
        if (this._downTexture) {
            this._currentTexture = this._downTexture;
            this._updateBtnGraphic();
        }
        if (this._label && this._label.json["down"])
            this._label.setColor(this._label.json["down"]);
        this._inDown = true;

        this._onDownHandler();
        super._down();
    }

    _over() {
        this._inButton = true;
        if (this._isBlock) return;
        if (this._inDown) return;
        if (this._overTexture) {
            this._currentTexture = this._overTexture;
            this._updateBtnGraphic();
        }
        if (this._label && this._label.json["over"])
            this._label.setColor(this._label.json["over"]);
        this._onOverHandler();
        super._over();
    }

    _out() {
        this._inButton = false;
        if (this._isBlock) return;
        if (this._inDown) return;
        if (this._outTexture) {
            this._currentTexture = this._outTexture;
            this._updateBtnGraphic();
        }
        if (this._label && this._label.json["fill"])
            this._label.setColor(this._label.json["fill"]);
        this._onOutHandler();
        super._out();
    }

    _upOutSide() {
        this._inDown = false;
        super._upOutSide();
    }

    _up() {
        if (this._isBlock) return;
        if (this._overTexture && this._inButton)
            this._currentTexture = this._overTexture;
        else
            this._currentTexture = this._outTexture;
        this._updateBtnGraphic();
        if (this._label && this._label.json["fill"])
            this._label.setColor(this._label.json["fill"]);
        if (!this._inDown) return;
        this._inDown = false;
        this._onUpHandler();
        this.onDoAction();
        super._up();
        if (this._oneClick)
            this.isBlock = true;
    }

    /**     * @public     */
    onDoAction() {

    }

    /**     * @public     */
    blockButton(state = true) {
        this.isBlock = state;
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------
    set label(value) {
        if (this._label) {
            this.removeChild(this._label);
            this._label.destroy(true);
        }
        this._label = value;
        if (value.parent !== this)
            this.addChild(value);
    }

    get label() {
        return this._label;
    }

    set hintLabel(value) {
        if (this._hintLabel) {
            this._hintLabel.destroy(true);
        }
        this._hintLabel = value;
        this._hintLabel.visible = false;
    }

    get isBlock() {
        return this._isBlock;
    }

    set isBlock(value) {
        if (this._isBlock && value || !this._isBlock && !value) return;
        if (value) {
            if (this._hintLabel) {
                if (this.parent) this.parent.removeChild(this._hintLabel);
                this._hintLabel.visible = false;
            }
            if (this._blockrTexture) {
                this._currentTexture = this._blockrTexture;
            } else {
                this._currentTexture = this._outTexture;
            }
            if (this._isHasBlockAlpha) {
                this._saveAlpha = this.alpha;
                this.alpha = this._blockAlphaLvl;
            }
        } else {
            this._currentTexture = this._outTexture;
            if (this._isHasBlockAlpha) this.alpha = this._saveAlpha;
        }
        this._updateBtnGraphic();
        if (this._label)
            if (value && this._label.json["block"])
                this._label.setColor(this._label.json["block"]);
            else if (!value && this._label.json["fill"])
                this._label.setColor(this._label.json["fill"]);
        this._isBlock = value;
        this.input = !value;
        this.buttonMode = !value;
    }

    set oneClick(value) {
        this._oneClick = value;
    }

    get outTexture() {
        return this._outTexture;
    }

    get overTexture() {
        return this._overTexture;
    }

    get downTexture() {
        return this._downTexture;
    }

    get blockTexture() {
        return this._blockrTexture;
    }

    set outTexture(value) {
        this._outTexture = value;
    }

    set overTexture(value) {
        this._overTexture = value;
    }

    set downTexture(value) {
        this._downTexture = value;
    }

    set blockTexture(value) {
        this._blockrTexture = value;
    }

    markObject() {
        this._debugRect = new OmyConst.Graphics();
        this._debugRect.position.set(this.worldX, this.worldY);
        this._debugRect.beginFill(0x008080, 0.5);

        let x = 0,
            y = 0;

        this._debugRect.drawRect(x, y, this.width, this.height);
        this._debugRect.endFill();
        this._debugRect.rotation = this.rotation;

        Omy.stage.addChild(this._debugRect);
    }

    clearMark() {
        if (this._debugRect && this._debugRect.parent) {
            Omy.stage.removeChild(this._debugRect);
        }
    }

    get inDown() {
        return this._inDown;
    }
}
